/**
 * Emits the synchronous "ramp.js executed" signal consumed by the optional
 * `ramp.watchdog.js` companion. Call this at the very top of every bundle entry
 * (production + debug), before any other work — the whole point is to prove the
 * bundle *ran*, independent of whether its later network work succeeds.
 *
 * Two signals, so the watchdog can either poll (script parsed before the
 * watchdog) or subscribe (watchdog parsed first):
 *   - `window.__RAMPJS_BOOTED__ = true` — a level flag readable at any time.
 *   - a `rampjs:boot` CustomEvent — an edge the watchdog can `addEventListener`.
 */
export function signalBoot(): void {
  window.__RAMPJS_BOOTED__ = true;
  window.dispatchEvent(new CustomEvent("rampjs:boot"));
}
